import React from "react";
import { ShieldCheckIcon, LockIcon, MailIcon } from "lucide-react";
import { guarantee } from "../data/contact";
import { GuaranteeSeal } from "./GuaranteeSeal";
export function GuaranteeSection() {
  const trust = [{
    icon: LockIcon,
    label: "Pago 100% seguro"
  }, {
    icon: MailIcon,
    label: "Acceso digital por correo"
  }, {
    icon: ShieldCheckIcon,
    label: `Garantía de ${guarantee.days} días`
  }];
  return <section id="garantia" className="bg-cream-50 py-14 sm:py-24" data-id="element-128" data-mp="jrr5czoqnxrs">
      <div className="mx-auto max-w-4xl px-5" data-id="element-129" data-mp="ntm5i0uxo53z">
        <div className="grid items-center gap-8 rounded-3xl border border-caramel-500/60 bg-cream-100 p-6 sm:p-10 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-130" data-mp="nsb3a5h4z5ez">
          <GuaranteeSeal days={guarantee.days} className="mx-auto h-40 w-40 drop-shadow-[0_12px_24px_rgba(28,17,11,0.25)] sm:h-48 sm:w-48" data-id="element-131" data-mp="xkgtparqpes2" />

          <div className="text-center md:text-left" data-id="element-132" data-mp="12klcj7g4ellg">
            <h2 className="font-display text-3xl font-semibold leading-tight text-cocoa-900 sm:text-4xl" data-id="element-133" data-mp="17hlhtg55bkbi">
              Pruébalo con tranquilidad <em className="font-medium text-caramel-600" data-id="element-134" data-mp="25sq6uyqpc94z">durante {guarantee.days} días</em>
            </h2>
            <p className="mt-4 leading-relaxed text-cocoa-700" data-id="element-135" data-mp="20r9a9ff938u7">
              Descarga los 6 volúmenes y los 4 bonos, revísalos y empieza tu plan. Si sientes que el material no es para ti, escríbenos dentro de los {guarantee.days} días posteriores a tu compra y te devolvemos el 100% de tu dinero. Sin preguntas incómodas.
            </p>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-cocoa-700" data-id="element-136" data-mp="2jj2399ubku1x">
          {trust.map(t => {
          const Icon = t.icon;
          return <li key={t.label} className="inline-flex items-center gap-2" data-id="element-137" data-mp="2arjmoxtgoc8b">
                <Icon className="h-4 w-4 text-caramel-600" aria-hidden="true" data-id="element-138" data-mp="378wczijce2hy" />
                {t.label}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}